// extracted by mini-css-extract-plugin
export var emailBlockLink = "_ji-0";